module.exports = "<app-canvas></app-canvas>\n"


//////////////////
// WEBPACK FOOTER
// /Users/ColeMarsteller/Desktop/agoogle/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main